import { render, staticRenderFns } from "./fixedDiscount.vue?vue&type=template&id=0452d539&scoped=true&"
import script from "./fixedDiscount.vue?vue&type=script&lang=js&"
export * from "./fixedDiscount.vue?vue&type=script&lang=js&"
import style0 from "./fixedDiscount.vue?vue&type=style&index=0&id=0452d539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452d539",
  null
  
)

export default component.exports